export enum PaymentSystem {
  FastSpring = 'FastSpring',
  Virtual = 'Virtual',
  AWSMarketplace = 'AWSMarketplace',
  Stripe = 'Stripe'
}
